"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useRouter } from "next/navigation";
import type React from "react";
import { useActionState, useEffect } from "react";
import { login, sendCode } from "@/actions/auth";
import { Logo } from "@/components/logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
export function LoginForm(t0) {
  const $ = _c(27);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      full: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const full = t1 === undefined ? false : t1;
  const router = useRouter();
  const [sendCodeState, sendCodeAction, sendCodePending] = useActionState(sendCode, undefined);
  const [loginState, loginAction, loginPending] = useActionState(login, undefined);
  let t2;
  let t3;
  if ($[4] !== loginState || $[5] !== router) {
    t2 = () => {
      if (loginState && "errors" in loginState && Object.keys(loginState.errors).length === 0) {
        router.back();
      }
    };
    t3 = [loginState, router];
    $[4] = loginState;
    $[5] = router;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex h-8 w-8 items-center justify-center rounded-md"><Logo size="sm" /></div>;
    t5 = <h1 className="text-xl font-extrabold">Inicia sesión</h1>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  const t6 = !full;
  let t7;
  if ($[10] !== full) {
    t7 = e => {
      if (full) {
        e.preventDefault();
        window.location.href = "/signup";
      }
    };
    $[10] = full;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="flex flex-col items-center gap-2">{t4}{t5}<div className="text-center text-sm">¿No tienes una cuenta?{" "}<Link href="/signup" replace={t6} onNavigate={t7} className="underline underline-offset-4">Regístrate</Link></div></div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== loginPending || $[16] !== loginState || $[17] !== sendCodePending || $[18] !== sendCodeState) {
    t9 = !sendCodeState || "errors" in sendCodeState ? <form action={sendCodeAction} className="flex flex-col gap-6"><div className="grid gap-2"><Label htmlFor="email">Correo electrónico</Label><Input id="email" type="email" name="email" placeholder={"Correo electr\xF3nico"} autoComplete="username" autoCapitalize="none" autoFocus={true} defaultValue={sendCodeState?.values.email ?? ""} required={true} /></div>{sendCodeState?.errors?.email && <p className="text-destructive-foreground text-sm">{sendCodeState.errors.email}</p>}<Button type="submit" disabled={sendCodePending} className="w-full">Enviar código</Button>{sendCodeState?.errors?.global && <p className="text-destructive-foreground text-sm">{sendCodeState.errors.global}</p>}</form> : <form action={loginAction} className="flex flex-col gap-6"><div className="grid gap-2"><Label htmlFor="code">Código recibido por correo</Label><Input id="code" type="text" name="code" placeholder={"C\xF3digo"} inputMode="text" maxLength={6} className="text-center text-lg tracking-widest" autoComplete="one-time-code" pattern="^[A-Za-z0-9]{6}$" autoFocus={true} defaultValue={loginState?.values.code ?? ""} required={true} /></div>{loginState?.errors.code && <p className="text-destructive-foreground text-sm">{loginState.errors.code}</p>}<Button type="submit" disabled={loginPending} className="w-full">Iniciar sesión</Button>{loginState?.errors.global && <p className="text-destructive-foreground text-sm">{loginState.errors.global}</p>}</form>;
    $[15] = loginPending;
    $[16] = loginState;
    $[17] = sendCodePending;
    $[18] = sendCodeState;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="flex flex-col gap-6">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== className || $[24] !== props || $[25] !== t10) {
    t11 = <div className={className} {...props}>{t10}</div>;
    $[23] = className;
    $[24] = props;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}